import { useMemo, useState } from "react";
import useAPI from "../../../../../hooks/useAPI";

/**
 * @typedef {object} Response
 * @prop {import("../interfaces").DoubtsData} data
 * @prop {object} paging
 * @prop {number} paging.pages
 * @prop {number} paging.total
 */

const defaultFilters = {};

export default function useFetchDoubts() {
  const [page, setPage] = useState(0);
  const [filters, setFilters] = useState(defaultFilters);

  const doubtUrl = useMemo(() => {
    const searchParams = new URLSearchParams();

    searchParams.append('page', (page || 0) + 1);
    searchParams.append('limit', 50);
    filters?.user && searchParams.append('user', filters.user);
    filters?.doubt && searchParams.append('doubt', filters.doubt);
    filters?.status && searchParams.append('status', filters.status);
    filters?.startDate && searchParams.append('startDate', filters.startDate);
    filters?.endDate && searchParams.append('endDate', filters.endDate);

    return `/admin/operacoes/controle-tickets-v3?${searchParams.toString()}`
  }, [page, filters]);

  /**@type {Response} */
  const { data, isLoading } = useAPI(doubtUrl);

  const onChangePage = (newPage) => {
    setPage(Math.max(newPage, 0));
  }

  const onSubmitFilters = (newFilters) => {
    setFilters(newFilters);
    onChangePage(0);
  }

  const onResetFilters = () => {
    onSubmitFilters(defaultFilters);
  }

  return {
    /**@type {Response} */
    data: data,
    /**@type {boolean} */
    isLoading,
    page,
    filters,
    onChangePage,
    onSubmitFilters,
    onResetFilters
  }
}